import { touchevents } from 'modernizr';
import { SET_VIEWPORT, SET_VIEWPORT_OVERLAY, SET_VIEWPORT_TITLE } from 'reducers/actions-types';
import { numerals } from 'util/dom/mq';

export default function viewportReducer(state = {
    height: 0,
    width: 0,
    touchevents,
    hasOverlay: false,
    title: document.title,
    isNative: /is_native/.test(window.location.search) || /\/webview/.test(window.location.href),
    isTablet: null,
    isDesktop: null,
    isMobile: null,
    mq: {},
}, { type, width, height, mq, hasOverlay, title }) {
    switch (type) {
        case SET_VIEWPORT_TITLE:
            document.title = title;
            return Object.assign({}, state, { title });
        case SET_VIEWPORT_OVERLAY:
            return Object.assign({}, state, { hasOverlay });
        case SET_VIEWPORT:
            return Object.assign({}, state, {
                width,
                height,
                mq,
                isMobile: mq.width <= numerals.SM,
                isTablet: mq.width <= numerals.MD && mq.width > numerals.XS,
                isDesktop: mq.width > numerals.SM,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/viewport/index.js